import { useState } from "react";
import CheckBox from "../CheckBox/CheckBox";
import Counter from "../Counter/Counter";
import IconButton from "../IconButton/IconButton";
import styles from "./ItemToPayComponent.module.scss";

interface ToppingModel {
  name: string;
  price: string;
}

export interface ItemToPayComponentProps {
  description: string;
  basePrice?: string;
  price: string;
  numericPrice?: number;
  toppings?: ToppingModel[];
  onCheckedChange?: (checked: boolean) => void;
  /** When given, the tile grows an info button that opens the item's details. */
  onDetails?: () => void;
  /**
   * Quantity mode: the trailing control becomes a stepper instead of a tick,
   * for lists where the same item may be taken more than once. Selection is
   * then "quantity above zero".
   */
  quantity?: number;
  onQuantityChange?: (quantity: number) => void;
  maxQuantity?: number;
}

function ItemToPayComponent(props: ItemToPayComponentProps) {
  const {
    description,
    basePrice,
    price,
    toppings,
    onCheckedChange,
    onDetails,
    quantity,
    onQuantityChange,
    maxQuantity,
  } = props;
  const countsQuantity = quantity !== undefined;
  const [checked, setChecked] = useState(false);
  const toggleChecked = () => {
    // In quantity mode the stepper owns the selection, so the row is inert.
    if (countsQuantity) return;
    const next = !checked;
    setChecked(next);
    onCheckedChange?.(next);
  };
  const isSelected = countsQuantity ? quantity > 0 : checked;
  return (
    <div
      className={`${styles.itemToPayContainer} ${
        isSelected ? styles.itemToPayContainerChecked : ""
      } ${countsQuantity ? styles.itemToPayStacked : ""}`}
      onClick={toggleChecked}
    >
      <div className={styles.itemToPayAndToppingWrapper}>
        <div className={styles.itemToPayComponent}>
          <div className={styles.itemToPayTextGroup}>
            <p className={`body-bold-medium ${styles.itemToPayDescription}`}>
              {description}
            </p>
          </div>
          <div className={styles.itemToPayTextGroup}>
            <p className={`body-medium ${styles.itemToPayBasePrice}`}>
              {basePrice}
            </p>
            <p className={`body-medium ${styles.itemToPayPrice}`}>{price}</p>
          </div>
        </div>
        {toppings &&
          toppings.map((topping) => (
            <div className={styles.itemToPayTopping}>
              <i
                className={`la-level-up-alt icon-medium ${styles.toppingArrow}`}
              />
              <p className={`body-medium ${styles.toppingDescription}`}>
                {`${topping.name} (${topping.price})`}
              </p>
            </div>
          ))}
      </div>
      <div className={styles.itemToPaySelectContainer}>
        {onDetails ? (
          <span onClick={(event) => event.stopPropagation()}>
            <IconButton
              iconName="las la-info-circle icon-xl"
              color="primary"
              variant="text"
              onClick={onDetails}
            />
          </span>
        ) : null}
        {countsQuantity ? (
          <span onClick={(event) => event.stopPropagation()}>
            <Counter
              value={quantity}
              onChange={(next) => onQuantityChange?.(next)}
              min={0}
              max={maxQuantity}
            />
          </span>
        ) : (
          <CheckBox checked={checked} toggleChecked={() => {}} />
        )}
      </div>
    </div>
  );
}

export default ItemToPayComponent;
